<script>
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: "WavedItems",
    props: {
        items: {
            type: Array,
            required: true
        },
        busy: {
            type: Boolean,
            required: true
        },
    },
    components: {
        LoadingTemplate,
        RawData
    },
    computed: {
        filtered(){
            let data = this.items;
            var total = this.currentPage * this.perPage;
            if(this.filter.trim() != "" && this.filter){
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            let data = this.items;
            if(this.filter.trim() != "" && this.filter){
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        }
    },
    data(){
        return {
            currentPage: 1,
            perPage: 10,
            filter: "",
            pageOptions: [10, 25, 50, 100],
        }
    },
    methods: {
        cancelSelectionOfItems(rfq){
            rfq.selectItems = false;
            rfq.rfqItems.map(x => x.selected = false);
            rfq.selectAll = false;
        },
        countItemSelected(rfq){
            return rfq.rfqItems.filter(x => x.selected).length;
        },
        recanvasItem(rfq){
            let items = rfq.rfqItems.filter(x => x.selected);
            if(items.length == 0){
                return this.showToast("Please select item(s) to recanvass", "error");
            }
            let data = [];
            items.forEach(x => {
                data.push(x.rfqItemId)
            })
            this.$store
                .dispatch("rfq/RecanvasItems", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    items.map(item => {
                        this.$emit('reawardItem', item)
                    })
                    this.$emit("refreshRecanvas");
                    this.showToast("Successfully recanvased", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        filteredRfqItems(rfq){
            let data = rfq.rfqItems;
            if(rfq.searchItem && rfq.searchItem != ""){
                data = data.filter(x => x.filterKey.toLowerCase().includes(rfq.searchItem.toLowerCase()))
            }
            return data;
        },
        getTotalPerPR(prItems) {
            return prItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.quantity * cv.apiResource.unitCost);
            }, 0);
        },
        selectAllItems(rfq){
            rfq.rfqItems.map(x => x.selected = rfq.selectAll)
        },
        selectRfqItem(rfq){
            let count = rfq.rfqItems.filter(x => x.selected).length;
            rfq.selectAll = count == rfq.rfqItems.length;
        },
        reawardItem(item){
            let items = item.rfqItems.filter(x => x.selected);
            if(items.length == 0){
                return this.showToast("Please select item(s) to reaward", "error");
            }
            this.$emit('reaward-rfq', item)
        }
    }
}
</script>
<template>
    <div>
        <div class="card">
            <div class="card-body bg-warning bg-soft">
                <div
                    class="
                        d-flex
                        align-items-center
                        mb-3
                        justify-content-between
                    "
                >
                    <div>
                        <h4 class="card-title mb-0">
                            Waved Items
                        </h4>
                        <p class="card-title-desc mb-0">
                            List of waved items
                        </p>
                    </div>
                    <div v-if="items.length > 0">
                        <div class="d-flex">
                            <input
                                autocomplete="off"
                                type="text"
                                v-model="filter"
                                placeholder="Search Waved Items..."
                                class="form-control"
                            />
                            <b-form-select
                                class="form-select ms-1 w-25"
                                v-model="perPage"
                                :options="pageOptions"
                            ></b-form-select>
                        </div>
                    </div>
                </div>
                <div v-if="items.length == 0 && !filter" class="text-center"><h5>No data available</h5></div>
                <div v-if="filtered.length == 0 && filter" class="text-center"><h5>Search not found</h5></div>
                <template v-if="items.length > 0">
                    <div
                        role="tablist"
                        v-for="(x, index) in filtered"
                        :key="x.id"
                    >
                        <b-card
                            no-body
                            class="mb-1 shadow-none"
                            :style="{'z-index': `${filtered.length - index}`}"
                        >
                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" :keyId="`waived-${index}`" placement="left"/>
                            <b-card-header
                                header-tag="header"
                                role="tab"
                                header-class="cursor-pointer"
                                @click="x.visible = !x.visible"
                            >
                                <div class="d-flex justify-content-between align-items-center">
                                    <h6 class="m-0">
                                        <a class="text-dark" href="javascript: void(0);">
                                            <span class="text-warning">[{{ x.rfqNumber}}]</span>
                                            <span>[{{x.prNumber}}]</span>:&nbsp;{{ x.description }}
                                        </a>
                                    </h6>
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <span class="d-flex align-items-center text-truncate">
                                                <small v-if="!x.visible">Click here to expand</small>
                                                <i class="bx bx-chevron-right rotate font-size-18 ms-3" :class="{'rotate-90': x.visible}"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </b-card-header>
                            <b-collapse
                                :visible="x.visible"
                                :accordion="`waved-item-accordion-${x.rfqId}`"
                                role="tabpanel"
                            >
                                <hr class="my-0"/>
                                <div class="p-3">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div v-if="!x.selectItems">
                                            <button type="button" class="btn btn-sm btn-outline-success" @click="x.selectItems = true"><i class="bx bx-list-check"></i> Select Items</button>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-between" v-if="x.selectItems">
                                            <div class="form-check form-checkbox-outline form-check-success">
                                                <input
                                                    type="checkbox"
                                                    :id="`select-all-items-${x.id}`"
                                                    checked="checked"
                                                    class="form-check-input"
                                                    v-model="x.selectAll"
                                                    @change="selectAllItems(x)"
                                                />
                                                <label :for="`select-all-items-${x.id}`" class="form-check-label">
                                                    Select all
                                                </label>
                                            </div>
                                            <span class="mx-2"></span>
                                            <button type="button" class="btn btn-sm btn-outline-warning" @click="cancelSelectionOfItems(x)"><i class="bx bx-x"></i> Cancel</button>
                                        </div>
                                        <div v-else>
                                            <input type="text" class="form-control form-control-sm" placeholder="Search item..." v-model="x.searchItem">
                                        </div>
                                        <div v-if="countItemSelected(x) > 0" class="d-flex align-items-center">
                                            With {{ countItemSelected(x) }} selected: 
                                            <button type="button" class="ms-1 btn btn-sm btn-outline-success" @click="recanvasItem(x)"><i class="bx bx-check"></i> Recanvas?</button>
                                            <button type="button" class="ms-1 btn btn-sm btn-outline-warning" @click="reawardItem(x)"><i class="bx bx-award"></i> Reaward?</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="px-3">
                                    <table
                                        class="
                                            table
                                            table-bordered
                                        "
                                    >
                                        <thead>
                                            <tr class="custom-border-2">
                                                <th>Item Name
                                                    <div><small>Item Description</small></div>
                                                </th>
                                                <th style="width: 120px;">Unit</th>
                                                <th style="width: 70px;">Qty</th>
                                                <th style="width: 150px;">Unit Cost</th>
                                                <th style="width: 150px;">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="!x.rfqItemLoading && x.rfqItems.length > 0">
                                                <tr
                                                    v-for="(z, zIndex) in filteredRfqItems(x)"
                                                    :key="`poffer-${z.rfqItemId}-${zIndex}`"
                                                >
                                                    <td class="position-relative">
                                                        <RawData 
                                                            :data="z"
                                                            placement="left"
                                                            :keyId="`rfq-item-${x.id}${z.iarItemId}`"
                                                            v-if="$store.state.decrypt.isAdmin()" 
                                                        />
                                                        <div class="d-flex">
                                                            <div style="min-width:20px;height:20px;" class="bg-success bg-gradient text-white d-flex align-items-center justify-content-center me-1">{{zIndex + 1}}</div>
                                                            <div 
                                                                v-if="!x.selectItems"
                                                            >
                                                                {{ z.apiResource.itemName}}
                                                            </div>
                                                            <div v-else>
                                                                <div
                                                                    class="
                                                                        form-check
                                                                        form-checkbox-outline
                                                                        form-check-success
                                                                    "
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        :id="`select-rfq-items-${z.iarItemId}`"
                                                                        class="form-check-input"
                                                                        v-model="z.selected"
                                                                        @change="selectRfqItem(x)"
                                                                    />
                                                                    <label
                                                                        :for="`select-rfq-items-${z.iarItemId}`"
                                                                        class="form-check-label"
                                                                    >
                                                                        {{ z.apiResource.itemName}}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div><small>{{ z.apiResource.description }}</small></div>
                                                    </td>
                                                    <td>
                                                        <div class="d-flex align-items-center">
                                                            {{ z.apiResource.unit.shortName }}
                                                        </div>
                                                    </td>
                                                    <td>{{ z.quantity}}</td>
                                                    <td> {{formatCurrency(z.apiResource.unitCost)}}</td>
                                                    <td>{{formatCurrency(z.apiResource.unitCost * z.quantity)}}</td>
                                                </tr>
                                            </template>
                                            <tr v-if="x.rfqItemLoading">
                                                <td colspan="5"><LoadingTemplate /></td>
                                            </tr>
                                            <tr v-if="!x.rfqItemLoading && x.rfqItems.length == 0">
                                                <td colspan="6" class="text-center">
                                                    <i>No items found</i>
                                                </td>
                                            </tr>
                                            <tr class="border border-dashed" v-if="!x.rfqItemLoading && x.rfqItems.length > 0">
                                                <td colspan="4" class="text-right py-2 px-2">Total RFQ Amount:</td>
                                                <td colspan="2" class="py-2">{{ formatCurrency(getTotalPerPR(x.rfqItems)) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-collapse>
                        </b-card>
                    </div>
                </template>
            </div>
        </div>
        <div class="mt-3" v-if="filtered.length != 0">
            <div
                class="
                    dataTables_paginate
                    paging_simple_numbers
                    float-end
                "
            >
                <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                </ul>
            </div>
        </div>
    </div>
</template>